import {
  Button,
  Copy,
  Flex,
  Heading,
  Square,
  Squish,
  Stack,
} from '@grubhubprod/gh-cookbook-react/dist';

import React from 'react';
import { Modal } from 'src/components/Modal/Modal';

interface IConfirmationModalProps {
  // this is a way of passing the id of some entity we are operating over like a LOC and return it back in callback
  id?: string;
  title: string;
  description: string;
  primaryActionText: string | JSX.Element;
  primaryActionFlavor?: string;
  disablePrimaryActionButton?: boolean;
  isPrimaryButtonLoading?: boolean;
  secondaryActionText?: string;
  secondaryButtonVariant?: 'secondary' | 'tertiary';
  disableSecondaryActionButton?: boolean;
  onSecondaryActionClick?: () => void;
  onPrimaryActionClick: (id?: string) => void;
  buttonsDirection: 'column' | 'column-reverse' | 'row' | 'row-reverse';
}

export function SimpleDialog({
  id,
  title,
  description,
  primaryActionText,
  secondaryActionText,
  secondaryButtonVariant = 'secondary',
  disablePrimaryActionButton,
  isPrimaryButtonLoading,
  disableSecondaryActionButton,
  onPrimaryActionClick,
  onSecondaryActionClick,
  buttonsDirection,
  primaryActionFlavor,
}: IConfirmationModalProps): JSX.Element {
  return (
    <Modal size="xs">
      <Squish inset="lg">
        <Stack y="sm">
          <Square
            as="header"
            width="100%"
            style={{ overflowWrap: 'break-word' }}
          >
            <Heading variant="h3" textAlign="left">
              {title}
            </Heading>
          </Square>
        </Stack>
        <Stack y="md">
          <Copy variant="body">{description} </Copy>
        </Stack>
        <Square as="footer">
          <Flex flexDirection={buttonsDirection}>
            {primaryActionText && (
              <Stack
                width="100%"
                y={buttonsDirection === 'column' ? 'sm' : 'none'}
                x={buttonsDirection === 'row' ? 'md' : 'none'}
              >
                <Button
                  block
                  variant="primary"
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  flavor={primaryActionFlavor as any} // not exported flavors type
                  isLoading={isPrimaryButtonLoading}
                  disabled={disablePrimaryActionButton}
                  buttonSize="medium"
                  onClick={() => onPrimaryActionClick(id)}
                >
                  {primaryActionText}
                </Button>
              </Stack>
            )}

            {secondaryActionText && (
              <Stack
                width="100%"
                y={buttonsDirection === 'column-reverse' ? 'sm' : 'none'}
                x={buttonsDirection === 'row-reverse' ? 'md' : 'none'}
              >
                <Button
                  block
                  variant={secondaryButtonVariant}
                  buttonSize="medium"
                  disabled={disableSecondaryActionButton}
                  onClick={onSecondaryActionClick}
                >
                  {secondaryActionText}
                </Button>
              </Stack>
            )}
          </Flex>
        </Square>
      </Squish>
    </Modal>
  );
}
